import {ChangeDetectionStrategy, Component, Input} from '@angular/core';
import {TagListBuilder} from '@shared/helper/tag-list-builder';
import {ReserveModel} from '@app/models/reserve';
import {SlotModel} from '@app/@core/domain/slot.model';
import {format} from 'date-fns';
import Reserve = ReserveModel.Reserve;
import Slot = SlotModel.Slot;


export function mapSlotSeverity({status}: Slot): Severity {
    if (status === 'OPEN') {
        return 'primary';
    } else if (status === 'CLOSE') {
        return 'danger';
    } else if (status === 'PAID') {
        return 'success';
    } else if (status === 'HIDE') {
        return 'warning';
    } else {
        return undefined;
    }
}

export function mapSlotToTag(slot: Slot): TagItem {
    return {
        name: format(slot.startDate, 'HH:mm'),
        severity: mapSlotSeverity(slot)
    };
}

export type Severity = 'primary' | 'success' | 'info' | 'warning' | 'danger';

export interface TagItem {
    name: string;
    severity: Severity;
}

function instanceOfReserve(object: any): object is Reserve {
    return 'golf' in object;
}

@Component({
    selector: 'app-tag-list',
    template: `
        <p-tag *ngFor="let tag of items"
               styleClass="mr-2 opacity-80 shadow-4"
               [value]="tag.name"
               [severity]="tag.severity"
        ></p-tag>
    `,
    styles: [],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class TagListComponent {
    @Input() items: TagItem[];

    static builder() {
        return new TagListBuilder();
    }
}
